module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('p', [_vm._v("页面载入前显示无淡入效果的loading")]), _vm._v(" "), _c('p', [_vm._v("点击 logo 显示含有淡入过渡的效果")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    },
    on: {
      "click": _vm.transitionDemo
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("使用方法及代码请看："), _c('a', {
    attrs: {
      "href": "https://github.com/kfw001/kfw-loading"
    }
  }, [_vm._v("kfw-loading")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112b05d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 11
// module chunks = 0